
/*@ngInject*/
const ClassCodeItemsRepository = function (baseCachedSharedPromiseRepository) {

    var sharedPromiseCache = {};

    angular.extend(this, baseCachedSharedPromiseRepository);

    this.getCacheName = function () {
        return 'classCodeItemsRepository';
    };

    this.getCacheCapacity = function () {
        return 100;
    };

    this.getSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.getClassCodeItems = function (classCodeType, searchString, effectiveDate) {
        var url = '/rest/ClassCode',
            config = {
                params: {
                    classCodeType: classCodeType,
                    searchString: searchString,
                    effectiveDate: moment(effectiveDate).utc().format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
                }
            },
            cacheKey = classCodeType + searchString + effectiveDate;

        return this.get(cacheKey, url, config);
    };

    this.getClassCodeItemsNoDate = function (classCodeType, searchString) {
        var url = '/rest/ClassCode',
            config = {
                params: {
                    classCodeType: classCodeType,
                    searchString: searchString
                }
            },
            cacheKey = classCodeType + searchString;

        return this.get(cacheKey, url, config);
    };

    this.processResponseData = function (responseData) {
        _.map(responseData, function (item) {
            item.value = item.description;
            item.description = (!_.isNil(item.codeDisplayText) ? item.codeDisplayText : item.code) + ' - ' + item.value;
            return item;
        });

        return responseData;
    };
};

angular.module('umFormViewer')
    .service('classCodeItemsRepository', ClassCodeItemsRepository);
